import React from 'react';
import { View, Text, StyleSheet, Platform, Dimensions } from 'react-native';
import { useTheme } from '@react-navigation/native';
import Ionicons from "@react-native-vector-icons/ionicons/static";
var width = Dimensions.get('window').width;



const CustomLabel = ({ value, type = "PRIMARY", containerStyle, textStyle, specificColor, textColor, hasNotification = false, notificationValue,
    iconName = undefined, sz = 18, show = '', align = 'center', fontSize = null
}) => {
    const { colors } = useTheme();
    const styles = makeStyles(colors, specificColor, textColor, align, fontSize);

    return (
        <View style={[
            styles.container,
            styles[`container_${type}`],
            containerStyle,
        ]}>
            {iconName && <Ionicons
                name={iconName}
                size={sz}
                style={[
                    styles.icon,
                    styles[`icon_${show}`],
                ]} >
            </Ionicons>}
            <Text
                style={[
                    styles.input,
                    styles[`input_${type}`],
                    textStyle,
                ]}>
                {value}
            </Text>
            {hasNotification && notificationValue !== undefined &&
                <View style={styles.container_NOTIFICATION} >
                    <Text
                        style={styles.input_NOTIFICATION}>
                        {notificationValue}
                    </Text>
                </View>}
        </View >
    )
};

const makeStyles = (colors, specificColor, textColor, align, fontSize) => StyleSheet.create({
    container: {
        backgroundColor: 'transparent',
    },
    input: {
        fontSize: 20,
        color: colors.text_primary,
        fontWeight: '700',
        fontFamily: 'Roboto-Medium',
    },
    icon: {
        marginHorizontal: 10,
        color: colors.text_primary,
    },

    container_DASHBOARD: {
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center'
    },
    input_DASHBOARD: {
        textAlign: 'center',
    },
    container_MINORTITLE: {
        marginHorizontal: 20,
        marginBottom: 0,
        marginTop: 20,
        flexDirection: 'row',
    },

    input_MINORTITLE: {
        fontSize: fontSize ?? 18,
        fontWeight: '700',
        marginBottom: 4,
    },

    container_MINORTITLE_MUTED: {
        flexDirection: 'row',
        marginHorizontal: 20,
    },

    input_MINORTITLE_MUTED: {
        fontSize: fontSize ?? 13,
        fontWeight: '700',
        color: colors.text_muted,
        marginBottom: 4,
    },

    container_SUBTITLE: {
        flex: 1,
        justifyContent: "center",
        marginVertical: 10,
    },

    input_SUBTITLE: {
        fontSize: fontSize ?? 16,
        fontWeight: '700',
        color: colors.text_muted,
        textAlign: 'center',
    },

    container_CARDTITLE: {
        margin: 5,
        flexDirection: 'row',
    },

    input_CARDTITLE: {
        fontSize: fontSize ?? 18,
        textAlign: 'left',
    },
    container_CARDTITLE_SECONDARY: {
        margin: 15,
        flexDirection: 'row',
    },

    input_CARDTITLE_SECONDARY: {
        fontSize: fontSize ?? 18,
        textAlign: 'left',
        color: colors.text_primary
    },

    container_CARDTITLE_MUTED: {
        margin: 15,
        flexDirection: 'row',
    },

    input_CARDTITLE_MUTED: {
        fontSize: fontSize ?? 18,
        textAlign: 'left',
        color: colors.text_muted
    },

    container_MINORTITLE_NOMARGIN: {
        flexDirection: 'row',
    },

    container_PART: {
        margin: 10,
        marginTop: '0',
        marginBottom: '0',
        justifyContent: 'center'
    },

    input_PART: {
        fontSize: 16,
    },

    container_SIDE_MENU: {
        margin: 10,
        justifyContent: 'center'
    },

    input_SIDE_MENU: {
        fontSize: 16,
    },

    container_NOTIFICATION: {
        width: 30,
        height: 30,
        marginTop: Platform.OS === 'web' && width > 1300 ? 12 : 0,
        marginLeft: 20,
        borderRadius: 30 / 2,
        backgroundColor: "#fa3e3e",
        justifyContent: 'center',
        alignItems: 'center'
    },

    input_NOTIFICATION: {
        fontSize: 15,
        textAlign: 'center',
    },


    container_TAB: {
        alignItems: 'center'
    },

    input_TAB: {
        fontSize: 14,
        textAlign: 'center'
    },

    container_EMERGENCY: {

    },

    container_ACCOUNT: {
        marginTop: '0%',
        marginBottom: '0%',
    },

    container_ACCOUNT_SENIORITY: {
        marginTop: '0%',
        marginBottom: '2%',
    },

    input_ACCOUNT: {
        textAlign: 'center'
    },

    input_ACCOUNT_SENIORITY: {
        fontSize: 18,
        textAlign: 'center',
    },

    container_MINOR: {
        flex: 1,
    },

    container_MAJOR: {

    },

    container_AVAILABLEUSED: {
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center'
    },

    input_AVAILABLEUSED: {
        fontSize: fontSize ?? 16,
        textAlign: 'center',
        color: colors.text_secondary
    },
    container_AVAILABLEUSED_SECONDARY: {
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: align,
        alignItems: align,
    },

    input_AVAILABLEUSED_SECONDARY: {
        fontSize: fontSize ?? 14,
        textAlign: 'center',
        color: colors.text_primary
    },
    container_AVAILABLEUSED_MUTED: {
        flex: 1,
        marginTop: 5,
        marginRight: 10,
        marginBottom: 0,
        justifyContent: align,
        alignItems: align,
    },

    input_AVAILABLEUSED_MUTED: {
        fontSize: fontSize ?? 12,
        textAlign: 'center',
        color: colors.text_muted
    },
    container_TITLE_MUTED: {
        marginTop: 5,
        marginBottom: 0,
        justifyContent: 'center'
    },

    input_TITLE_MUTED: {
        fontSize: 12,
        textAlign: 'center',
        color: colors.text_muted
    },


    container_ASSMLINE: {
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center'
    },

    input_ASSMLINE: {
        fontSize: 12,
        textAlign: Platform.OS === 'web' ? 'center' : 'left'
    },

    container_TIMESHEET: {
        flex: 1,
        flexDirection: 'row',
        flexShrink: 1,
        marginTop: 0,
        marginBottom: 0,
        margin: 10,
        justifyContent: 'center', // Center the content vertically
        alignItems: 'center', // Center the content horizontally
    },

    input_TIMESHEET: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlignVertical: 'center', // Vertically align the text within the Text component (Android only)
        textAlign: 'center', // Horizontally align the text within the Text component
    },
    container_TIMESHEET_WIDER: {
        flex: 4,
        flexDirection: 'row',
        flexShrink: 1,
        marginTop: 0,
        marginBottom: 0,
        margin: 5,
        justifyContent: 'center', // Center the content vertically
        alignItems: 'center', // Center the content horizontally
    },

    input_TIMESHEET_WIDER: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlignVertical: 'center', // Vertically align the text within the Text component (Android only)
        textAlign: 'center', // Horizontally align the text within the Text component
    },

    container_SUBTITLENOFLEX: {
        marginHorizontal: 10,
        justifyContent: "center",
    },

    input_SUBTITLENOFLEX: {
        fontSize: 16,
        textAlign: 'center'
    },

    container_SUBTITLEPROGRESS: {
        flex: 1,
        justifyContent: "center",
        margin: Platform.OS === 'web' ? 15 : 5,
    },

    input_SUBTITLEPROGRESS: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        color: colors.text_muted,
        textAlign: 'center'
    },


    container_SUBTITLEADMIN: {
        flex: 1,
        marginLeft: '2%',
        justifyContent: "center"
    },

    input_SUBTITLEADMIN: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlign: 'center'
    },
    container_MAIN_LABEL_TEAM_SCHEDULE: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 16,
        paddingVertical: 10,
        paddingHorizontal: 14,
        backgroundColor: colors.buttons_primary,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 10,
    },
    input_MAIN_LABEL_TEAM_SCHEDULE: {
        fontSize: 13,
        fontWeight: '600',
        color: colors.text_secondary,
        flex: 1,

    },

    container_MAIN_LABEL_DASHBOARD: {
        flex: 1,
        marginTop: 3,
        marginBottom: 3,
        marginLeft: 10,
    },
    input_MAIN_LABEL_DASHBOARD: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
    },

    container_MAIN_LABEL_DASHBOARD_MINOR: {
        flex: 1,
        marginTop: 3,
        marginBottom: 3,
        marginLeft: 10,
    },
    input_MAIN_LABEL_DASHBOARD_MINOR: {
        color: colors.text_muted,
        fontSize: Platform.OS === 'web' ? 16 : 12,
    },

    container_STATUS: {
        flex: 1,
        justifyContent: 'center',
        borderRadius: 20,
        padding: 5,
        marginTop: 0,
        marginBottom: 3,
        marginLeft: 1,
        marginRight: 1,
        backgroundColor: specificColor
    },

    input_STATUS: {
        fontSize: 14,
        textAlign: 'center',
        fontWeight: '800',
        letterSpacing: 0.4,
    },

    container_CHILDREN: {
    },

    container_MYPROFILE: {
        width: '100%',
        marginTop: 15,
        marginLeft: 0,
    },

    input_MYPROFILE: {
        fontSize: 16,
        textAlign: 'left',
    },

    input_EMERGENCY: {
        fontSize: 16,
        color: colors.buttons_primary,
        padding: 10,
        width: '100%',
        textAlign: 'left',
    },

    container_NEWREQUESTLABEL: {
        marginVertical: 8,
    },

    input_NEWREQUESTLABEL: {
        fontSize: 16,
        marginLeft: Platform.OS === 'web' ? 5 : 16,
    },

    container_NEWREQUESTLABELWARNING: {
        margin: '3%',
    },

    input_NEWREQUESTLABELWARNING: {
        fontSize: 14,
        fontStyle: 'italic'
    },

    container_MAJORSETTINGS: {

    },
    input_MAJORSETTINGS: {
        fontSize: 16,
    },

    input_MAJOR: {
        fontSize: 16,
        paddingLeft: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "1%",
        marginBottom: "1%",
    },

    input_MINOR: {
        fontSize: 16,
        paddingLeft: 10,
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    },
    container_MINOROVERLAP: {
        flex: 1,
    },

    input_MINOROVERLAP: {
        fontSize: 16,
        fontWeight: 'bold',
        paddingLeft: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "3%",
        marginBottom: "1%",
    },

    container_AVAILABLEUSED_SMALL: {
        justifyContent: 'flex-start',
        marginTop: 10,
        marginBottom: 10,
        flex: 1,

    },
    input_AVAILABLEUSED_SMALL: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'left',
        marginLeft: 10
    },

    container_CARDDESCRIPTION: {
        flex: 1,
        flexWrap: 'wrap',
        width: '100%',
    },

    input_CARDDESCRIPTION: {
        fontSize: 14,
        color: colors.text_secondary,
        flexWrap: 'wrap',
    },

    container_LEAVEDETAILSMAJOR: {
        width: Platform.OS === 'web' && width > 1300 ? '50%' : 100,
        marginRight: Platform.OS === 'web' ? 20 : 5,
        margin: Platform.OS === 'web' ? 20 : 0,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center'
    },
    container_LEAVEDETAILSMINOR: {
        width: Platform.OS === 'web' && width > 1300 ? '50%' : 100,
        margin: Platform.OS === 'web' ? 20 : 5,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center'
    },

    input_LEAVEDETAILSMINOR: {
        fontSize: 14,
        color: colors.text_secondary,
    },

    container_LEAVEDETAILSMINOR_NOMARGIN: {
        width: '100%',
        margin: 0,
        justifyContent: 'flex-start'
    },

    input_LEAVEDETAILSMINOR_NOMARGIN: {
        fontSize: 14,
        color: colors.text_secondary,
    },

    container_TSDETAILSMINOR: {
        width: Platform.OS === 'web' && width > 1300 ? '50%' : 100,
        margin: Platform.OS === 'web' ? 20 : 5,
        marginTop: 0,
        marginBottom: 0,
        flexShrink: 1,
        flex: 1,
        justifyContent: 'center'
    },

    input_TSDETAILSMINOR: {
        fontSize: 14,
    },

    container_LEAVEDETAILSMINORLINK: {
        width: Platform.OS === 'web' && width > 1300 ? '100%' : 100,
        margin: 20,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center'
    },
    input_LEAVEDETAILSMINORLINK: {
        fontSize: 16,
        color: '#0078e0',
        paddingLeft: 20,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    container_TSDETAILSMINORLINK: {
        width: '70%',
        margin: Platform.OS === 'web' ? 20 : 5,
        marginTop: 0,
        marginBottom: 0,
        flexShrink: 1,
        justifyContent: 'center'
    },

    input_TSDETAILSMINORLINK: {
        fontSize: 14,
        color: '#0078e0',
    },
    container_RESULTS_SURVEY: {
        width: '100%',
        flexShrink: 1,
        justifyContent: 'center',
    },

    input_RESULTS_SURVEY: {
        fontSize: 14,
        textAlign: 'left'
    },
    container_TIMESHEET_APPROVE: {
        flexShrink: 1,
        justifyContent: 'center',
    },

    input_TIMESHEET_APPROVE: {
        fontSize: Platform.OS === 'web' ? 14 : 12,
        textAlign: 'left'
    },
    container_ASSM: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_ASSM: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_REP: {
        flex: 1,
        margin: 5,
        flexShrink: 1,
    },
    input_REP: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_ASSM_MARGHOR: {
        marginTop: 20,
        marginHorizontal: 10,
        flexShrink: 1,
    },
    input_ASSM_MARGHOR: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_COMPANY: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_COMPANY: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_ASSMMINOR: {
        flex: 1,
    },
    input_ASSMMINOR: {
        fontSize: 14,
    },
    container_ASSMMINORBOX: {
    },
    input_ASSMMINORBOX: {
        fontSize: 14,
        // textAlign: 'left'
    },
    container_BOXESRESULT: {
        flex: 1,
        margin: 10,
    },
    input_BOXESRESULT: {
        fontSize: 16,
    },
    container_BOXESRESULTVALUE: {
        flex: 1,
        margin: 10,
    },
    input_BOXESRESULTVALUE: {
        fontSize: 14,
        fontWeight: 'bold',
    },
    container_ASSMBOX: {
        flex: 1,
        justifyContent: 'center',
    },
    input_ASSMBOX: {
        fontSize: 14,
        textAlign: 'center'
    },
    container_ASSMRESP: {
        width: '20%',
    },
    input_ASSMRESP: {
        fontSize: 14,
        textAlign: 'left'
    },
    container_ASSMRESPLABEL: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center'
    },
    input_ASSMRESPLABEL: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_CHECKBOXLABEL: {
        width: 'fit-content',
        flexShrink: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },

    input_CHECKBOXLABEL: {
        fontSize: 17,
        textAlign: 'left',
        textAlignVertical: 'center',
    },
    container_CHECKBOXLABELREP: {
        width: 'fit-content',
        flexShrink: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },

    input_CHECKBOXLABELREP: {
        fontSize: 15,
        textAlign: 'left',
        textAlignVertical: 'center',
    },
    container_LEAVEDETAILSMAJOR_FULL: {
        width: Platform.OS === 'web' && width > 1300 ? '100%' : 100,
        marginTop: 0,
        marginBottom: 0,
    },
    input_LEAVEDETAILSMAJOR_FULL: {
        fontSize: 16,
        fontWeight: 'bold',
    },

    container_error: {
        marginLeft: 0,
        marginTop: Platform.OS === 'web' && width > 1300 ? 10 : 5,
        marginBottom: 5,
    },
    container_MINORDATE: {
        width: '35%',
        alignItems: 'center',
    },
    input_MINORDATE: {
        fontSize: 14,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "1%",
        marginBottom: "1%",
    },
    input_error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14
    },
    input_LEAVEDETAILSMAJOR: {
        fontSize: 14,
        fontWeight: 'bold',
    },

    input_MINOR_extrapadding: {
        fontSize: 15,
        paddingLeft: '13%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "1%",
        marginBottom: "1%",
    },

    input_CHILDREN: {
        fontSize: 15,
        marginBottom: '5%',
        marginRight: '5%',
    },

    container_NEW_REQUEST_NO_ATTACHMENTS: {
        padding: 7,
    },

    input_NEW_REQUEST_NO_ATTACHMENTS: {
        paddingHorizontal: 5,
        color: '#a1a1a1',
        fontSize: 16,
        marginTop: 0,
    },

    container_NEW_REQUEST_ATTACHMENTS: {
    },

    input_NEW_REQUEST_ATTACHMENTS: {
        fontSize: 16
    },

    container_NEW_DOCUMENT: {
        width: '100%',
        marginLeft: 0,
        flex: 1
    },

    input_NEW_DOCUMENT: {
        fontSize: 15,
        textAlign: 'left',
    },

    container_COMING_SOON: {
        flex: 1,
        justifyContent: 'center',
    },

    input_COMING_SOON: {
        fontSize: 22,
        textAlign: 'center',
    },

    container_SELECT_EMPLOYEE: {
        width: '100%',
        marginLeft: 0,
        flex: 1
    },

    input_SELECT_EMPLOYEE: {
        fontSize: 15,
        textAlign: 'left',
    },

    container_SELECT_EMPLOYEE_NO_SELECTED_COMPANY: {
        width: '75%',
        marginLeft: 0,
        marginVertical: 10,
    },

    input_SELECT_EMPLOYEE_NO_SELECTED_COMPANY: {
        fontSize: 16,
        color: colors.text_muted,
        textAlign: 'left',
    },

    container_SELECT_EMPLOYEE_SELECTED_COMPANY: {
        width: '75%',
        marginLeft: 10,
        marginVertical: 10,
    },

    input_SELECT_EMPLOYEE_SELECTED_COMPANY: {
        fontSize: 16,
        color: colors.text_muted,
        textAlign: 'left',
    },

    container_IMAGE_TEXT: {
    },

    input_IMAGE_TEXT: {
        fontSize: 15,
        paddingLeft: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "1%",
        marginBottom: "1%",
    },

    container_BRANCHES_WHEN_SHOWING_LOCATIONS: {
        flex: 1,
        width: "90%",
        marginLeft: 0,
        marginTop: 0,
        marginBottom: 0,
    },

    input_BRANCHES_WHEN_SHOWING_LOCATIONS: {
        textAlign: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        fontSize: 16,
    },

    container_NO_BRANCHES: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
        justifyContent: 'center',
    },
    input_NO_BRANCHES: {
        fontSize: 20,
        textAlign: 'center',
    },

    container_NO_LOCATIONS: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
        justifyContent: 'center',
    },
    input_NO_LOCATIONS: {
        fontSize: 20,
        textAlign: 'center',
    },

    container_BRANCHES_LEFT: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_BRANCHES_LEFT: {
        fontSize: 20,
        textAlign: 'left',
    },

    container_BRANCHES_CENTER: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_BRANCHES_CENTER: {
        fontSize: 20,
        textAlign: 'center',
    },

    container_MASS_UPLOAD_CENTER: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_MASS_UPLOAD_CENTER: {
        fontSize: 20,
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#333',
    },


    container_DEPARTMENT_SUBCATEGORIES: {
        flex: 1,
        padding: 10,
    },

    input_DEPARTMENT_SUBCATEGORIES: {
        fontSize: 20,
        textAlign: 'left'
    },

    container_NO_FUNCTIONS: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
        justifyContent: 'center',
    },
    input_NO_FUNCTIONS: {
        fontSize: 20,
        textAlign: 'center',
    },

    container_SERVICELINES_LEFT: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_SERVICELINES_LEFT: {
        fontSize: 20,
        textAlign: 'left',
    },

    container_SERVICELINES_CENTER: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
    },
    input_SERVICELINES_CENTER: {
        fontSize: 20,
        textAlign: 'center',
    },

    container_EDIT_EMPLOYEE: {
        flex: 1,
        margin: 5,
        flexShrink: 1,
    },
    input_EDIT_EMPLOYEE: {
        fontSize: 17,
        textAlign: 'left'
    },

    container_EDIT_EMPLOYEE_DIVIDER: {
        flex: 1,
        margin: 10,
        flexShrink: 1,
    },
    input_EDIT_EMPLOYEE_DIVIDER: {
        fontSize: 17,
        fontWeight: '800',
        textTransform: 'uppercase',
        letterSpacing: 1,
        color: colors.text_muted,
    },

    container_EDIT_EMPLOYEE_IMPORTANT: {
        flex: 1,
        margin: 5,
        flexShrink: 1,
    },
    input_EDIT_EMPLOYEE_IMPORTANT: {
        fontSize: 15,
        fontWeight: '700',
        textAlign: align,
        textTransform: 'uppercase',
        letterSpacing: 1,
        color: colors.text_muted,
    },

    container_EDIT_EMPLOYEE_HEADER: {
        flex: 1,
        flexShrink: 1,
    },
    input_EDIT_EMPLOYEE_HEADER: {
        fontSize: 15,
        textAlign: 'left',
        textDecorationLine: 'underline',
    },

    container_EDIT_EMPLOYEE_STATE: {
        flex: 1,
        marginHorizontal: 5,
    },
    input_EDIT_EMPLOYEE_STATE: {
        fontSize: 17,
        textDecorationLine: 'underline',
    },

    container_EDIT_EMPLOYEE_BAD_STATE: {
        flex: 1,
        marginHorizontal: 5,
    },
    input_EDIT_EMPLOYEE_BAD_STATE: {
        fontSize: 17,
        textDecorationLine: 'underline',
        color: 'red',
    },

    container_EDIT_EMPLOYEE_LOADING: {
        flex: 1,
        margin: 5,
        flexShrink: 1,
        width: "100%",
        padding: 7,
        marginHorizontal: '5%'
    },
    input_EDIT_EMPLOYEE_LOADING: {
        fontSize: 17,
        textAlign: 'left'
    },
    container_SUBTITLE_TIMESCHEMES: {
        flex: 1,
        marginHorizontal: Platform.OS === 'web' ? 0 : 1
    },

    input_SUBTITLE_TIMESCHEMES: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlign: 'center',
    },

    container_USERROLE_LABEL: {
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },

    input_USERROLE_LABEL: {
        flex: 1,
        fontSize: 16,
    },
    container_SUBTITLE_LEFT: {
        flex: 1,
        marginHorizontal: Platform.OS === 'web' ? 0 : 1
    },

    input_SUBTITLE_LEFT: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlign: 'center',
    },
    container_IMAGE_TEXT_AUTH_COMPANIES: {
    },

    input_IMAGE_TEXT_AUTH_COMPANIES: {
        fontSize: 20,
        paddingLeft: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "1%",
        marginBottom: "1%",
    },


    container_EDIT_EMPLOYEE_EXPANDABLE: {
        margin: 10,
        width: '100%',
        backgroundColor: 'transparent',
        borderBottomWidth: 2,
        borderBottomColor: colors.buttons_primary,
        alignItems: 'flex-start',
        paddingTop: '1%',
        paddingBottom: '1%',
    },

    input_EDIT_EMPLOYEE_EXPANDABLE: {
        fontSize: Platform.OS === 'web' ? 16 : 12,
        textAlign: 'center',
    },
    container_ORGCHART: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    input_ORGCHART: {

    },
    container_FILTER: {
        marginHorizontal: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    container_CLEAR: {
        flex: 1,
        marginTop: 0,
        marginBottom: 0,
        justifyContent: 'center',
        alignItems: 'flex-end',
        marginHorizontal: 10,
        marginBottom: 10,
    },
    input_CLEAR: {
        fontSize: 14,
        color: colors.calendarArrow,
        textDecorationLine: 'underline',
        textAlign: Platform.OS === 'web' ? 'center' : 'left',
    },
    input_TITLE: {
        fontSize: 20,
        textAlign: 'left',
        marginVertical: 15,
    },
    container_SIDEMENU_OPTION: {
        flex: 1,
        margin: 20,
        flexShrink: 1,
        justifyContent: 'center',
    },
    input_SIDEMENU_OPTION: {
        fontSize: 18,
        textAlign: 'center',
    },
});

export default CustomLabel;